import React, { useContext, useState, useRef } from 'react';
import {
  InputText,
  FormContext,
  Button,
  ThemeContext,
  Menu,
} from 'skybolt-ui';
import { useQuery } from 'skybolt-api';


// With a talent id supplied by the containing form, show the talent fullName
// and update the form when the input is changed.
export default function InputTalent(props) {
  const form = useContext(FormContext);
  const talentId = form.get('talentId');
  const talentName = form.get('talentName');
  const talentImage = form.get('talentImage');

  const [query, setQuery] = useState(talentName || "");

  const data = useQuery(`{
    search: talents(search:$search, limit:5) {
      talentId
      fullName
      legalName
      image(width:150, height:150, face:true)
    }
  }`, {search:{query, status:["PAID", "TRIAL", "EXPIRED", "CANCELED"]}});


  const emitChange = talent => {
    setQuery(talent.legalName || talent.fullName);
    form.update({
      talentName: talent.legalName || talent.fullName,
      talentId: talent.talentId,
      talentImage: talent.image
    });
    if(props.onChange) {
      props.onChange(talent);
    }
  };

  const handleInputChange = value => {
    setQuery(value);
    if(!value) {
      form.update({
        talentName: "",
        talentId: null,
        talentImage: null,
      });
    }
  };

  const handleBlur = () => {
    setQuery(talentName);
    setFocused(false);
  }

  const theme = useContext(ThemeContext);

  const containerRef = useRef();
  const inputRef = useRef();
  const [focused, setFocused] = useState(false);


  return (
    <div style={{display:'flex', alignItems:'flex-start', justifyContent:'stretch', marginBottom:16, ...props.style}} ref={containerRef} className={props.className}>
      {talentImage && (
        <img src={talentImage} alt="Headshot" style={{width:46, height:46, marginRight:4}}/>
      )}
      <InputText
        value={query}
        onChange={handleInputChange}
        style={{flex:1, marginBottom:0}}
        onFocus={() => setFocused(true)}
        onBlur={handleBlur}
        ref={inputRef}
        title={props.title}
        hint={props.hint}
        error={props.error}
        clearable
      />
      <Menu key="menu" open={query && data && data.search.length && focused} anchor={containerRef} onRequestClose={() => inputRef.current.blur()}>
        {data && data.search && data.search.map((talent, i) =>
          <Button
            key={talent.talentId || i}
            style={{
              display: 'block',
              minWidth: 80,
              backgroundColor: talent.talentId === talentId ? theme.color.accent : 'transparent',
              borderRadius: 0,
            }}
            onMouseDown={e => e.preventDefault()}
            onClick={e => emitChange(talent)}>
            {talent.fullName} {talent.legalName ? `(${talent.legalName})` : ""}
          </Button>
        )}
      </Menu>
    </div>
  );

}